export const EVENT_NAME = "insight_action";